import { useGetOGPUserInfo } from 'ogp/hooks';
import { hasAccessWithinPolicyGroup, PolicyGroups } from 'shared/utils/policy-controller';
import { BranchOfficeRole } from '@types';
import { usePlanningContext } from '../../providers/planning-actions-provider';

export const useGetActions = (activeRoute?: string) => {
  const { setSidebarState, selectedShiftIds } = usePlanningContext();
  const userInfoQuery = useGetOGPUserInfo();
  const userHasAccessToCreateShift =
    userInfoQuery.data != null &&
    hasAccessWithinPolicyGroup(
      PolicyGroups.DEPARTMENT,
      userInfoQuery.data?.userInfo,
      BranchOfficeRole.PLANNER
    );

  return [
    {
      label: 'Voeg shift toe',
      onClick: () => setSidebarState('create'),
      disabled: !userHasAccessToCreateShift,
    },
    ...(activeRoute === 'table'
      ? [
          {
            label: 'Wijzig meerdere shifts',
            onClick: () => setSidebarState('bulk-edit'),
            disabled: selectedShiftIds && selectedShiftIds.length === 0,
          },
          {
            label: 'Archiveer shifts',
            onClick: () => setSidebarState('bulk-archive'),
            disabled: selectedShiftIds && selectedShiftIds.length === 0,
          },
        ]
      : []),
  ];
};
